import { render, staticRenderFns } from "./clientsfilter.vue?vue&type=template&id=1c8973f2"
import script from "./clientsfilter.vue?vue&type=script&lang=js"
export * from "./clientsfilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports